import { render, staticRenderFns } from "./LogoutModal.vue?vue&type=template&id=06f0236e&scoped=true&"
import script from "./LogoutModal.vue?vue&type=script&lang=ts&"
export * from "./LogoutModal.vue?vue&type=script&lang=ts&"
import style0 from "./LogoutModal.vue?vue&type=style&index=0&id=06f0236e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0236e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f0236e')) {
      api.createRecord('06f0236e', component.options)
    } else {
      api.reload('06f0236e', component.options)
    }
    module.hot.accept("./LogoutModal.vue?vue&type=template&id=06f0236e&scoped=true&", function () {
      api.rerender('06f0236e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shared/layouts/components/LogoutModal.vue"
export default component.exports